export enum BackgroundTaskZipFileTypes {
  ONE_PDF = 'one_pdf',
  MULTIPLE_PDF = 'multiple_pdf'
}
